import styled, { css } from 'styled-components'

const patternWidth = 'max(100vw, calc(100vh * 16 / 9))'
const cell = `calc(${patternWidth} / 16)`
const halfCell = `calc(${patternWidth} / 32)`

const backgroundLayers = shapes => css`
  background-image:
    url('${shapes}'),
    ${props => `radial-gradient(circle, ${props.theme.colors.overlay.onMediaLight} 4px, transparent 4px)`},
    ${props => `linear-gradient(${props.theme.colors.overlay.onMediaLight} 1px, transparent 1px)`},
    ${props => `linear-gradient(90deg, ${props.theme.colors.overlay.onMediaLight} 1px, transparent 1px)`};
`

export const BrandedBackground = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${props => props.theme.colors.primary.default};
  ${backgroundLayers('/images/login-background-shapes-animated.svg')}
  background-position:
    0 0,
    ${halfCell} ${halfCell},
    0 0,
    0 0;
  background-size:
    ${patternWidth} auto,
    ${cell} ${cell},
    ${cell} ${cell},
    ${cell} ${cell};
  background-repeat: no-repeat, repeat, repeat, repeat;

  @media (prefers-reduced-motion: reduce) {
    ${backgroundLayers('/images/login-background-shapes.svg')}
  }
`
